export const container = () => ({
    width: '100%',
    height: '100%',

    maxWidth: '37.875rem',
    maxHeight: '38.1875rem',

    tablet: {
        maxWidth: '22rem',
    },

    tabletLarge: {
        maxWidth: '37.875rem',
    },

    position: 'absolute',
    right: '15%',
});

export const image = () => ({
    maxHeight: '100%',
});
